































import firebase from 'firebase'

export default {
  name: 'Login'

  # data: ->

  computed:
    loginVisible: -> not this.$store.getters.user?
    version: -> this.$store.getters.version
    loginVisible: -> not this.$store.getters.user?

  methods:
    logIn: ->
      console.log "logIn"
      provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithRedirect(provider);
      this.$store.commit('setLoading', true)

    startDemo: ->
      console.log "startDemo"
      firebase.auth().signInAnonymously().catch (error) =>
        console.log error
        this.$notify.error({ title: 'Sign in Error', message: error.message })

  # created: ->
  # mounted: ->
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue